export const TRAVELSOMO_REGISTER_URL = "https://travelsomo.com/register";

export const COUNTRY_LANGUAGE_ROUTES = {
  IL: "/he",
  US: "/en",
  GB: "/en",
  GR: "/el",
  FR: "/fr",
  ES: "/es",
  IT: "/it",
  DE: "/de",
};

export const TRAVELSOMO_REDIRECT_COPY = {
  English: {
    title: "Register at TRAVELSOMO",
    body: "HotelsRiver is available in Israel. For your location, registration continues at TRAVELSOMO.COM.",
    cta: "Continue to registration",
    hint: "Taking you to travelsomo.com/register…",
  },
  Greek: {
    title: "Εγγραφή στο TRAVELSOMO",
    body: "Το HotelsRiver είναι διαθέσιμο στο Ισραήλ. Για την τοποθεσία σας, η εγγραφή συνεχίζεται στο TRAVELSOMO.COM.",
    cta: "Συνέχεια στην εγγραφή",
    hint: "Μεταφορά στο travelsomo.com/register…",
  },
  French: {
    title: "Inscription sur TRAVELSOMO",
    body: "HotelsRiver est disponible en Israël. Pour votre région, l'inscription se poursuit sur TRAVELSOMO.COM.",
    cta: "Continuer vers l'inscription",
    hint: "Redirection vers travelsomo.com/register…",
  },
  Spanish: {
    title: "Registro en TRAVELSOMO",
    body: "HotelsRiver está disponible en Israel. Para tu ubicación, el registro continúa en TRAVELSOMO.COM.",
    cta: "Continuar al registro",
    hint: "Te llevamos a travelsomo.com/register…",
  },
  Italian: {
    title: "Registrazione su TRAVELSOMO",
    body: "HotelsRiver è disponibile in Israele. Per la tua area, la registrazione continua su TRAVELSOMO.COM.",
    cta: "Continua alla registrazione",
    hint: "Ti stiamo portando su travelsomo.com/register…",
  },
  German: {
    title: "Registrierung bei TRAVELSOMO",
    body: "HotelsRiver ist in Israel verfügbar. Für Ihren Standort geht die Registrierung auf TRAVELSOMO.COM weiter.",
    cta: "Weiter zur Registrierung",
    hint: "Weiterleitung zu travelsomo.com/register…",
  },
};

export function getTravelsomoRedirectCopy(language) {
  return TRAVELSOMO_REDIRECT_COPY[language] || TRAVELSOMO_REDIRECT_COPY.English;
}

export const COUNTRY_OPTIONS = [
  { code: "IL", country: "Israel", language: "Hebrew", flag: "🇮🇱" },
  { code: "US", country: "United States", language: "English", flag: "🇺🇸" },
  { code: "GB", country: "United Kingdom", language: "English", flag: "🇬🇧" },
  { code: "GR", country: "Greece", language: "Greek", flag: "🇬🇷" },
  { code: "FR", country: "France", language: "French", flag: "🇫🇷" },
  { code: "ES", country: "Spain", language: "Spanish", flag: "🇪🇸" },
  { code: "IT", country: "Italy", language: "Italian", flag: "🇮🇹" },
  { code: "DE", country: "Germany", language: "German", flag: "🇩🇪" },
];
